<template>
    <header class="pp-header" :class="{'pp-header--fixed': fixed, 'color': color,}">
        <div class="pp-header__prefix">
            <slot name="prefix"></slot>
        </div>
        <div class="pp-header__title">
            <slot>{{title}}</slot>
        </div>
        <div class="pp-header__suffix">
            <slot name="suffix"></slot>
        </div>
    </header>
</template>

<script>
/**
 * 顶部栏
 * @param {boolean} fixed 固定在顶部
 * @param {string} title 标题 可以通过slot default的方式插入
 * @param {boolean} color 带背景色
 */
export default {
    name: 'pp-header',
    props: {
        fixed: Boolean,
        title: String,
        color: Boolean,
    },
    created: function() {
        if(this.$parent.$options.name === 'pp-container') {
            this.$parent.hasHeader = true
        }
    },
}
</script>
